import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatCheckbox} from "@angular/material/checkbox";

import {OptionItem} from "@app/shared/interfaces/optionItem.interface";

@Component({
  selector: 'app-filter-checkbox',
  imports: [
    MatCheckbox,
    ReactiveFormsModule
],
  templateUrl: './filter-checkbox.component.html'
})

export class FilterCheckboxComponent implements OnChanges, OnInit {
  @Output() selectionSubmitted = new EventEmitter<number[]>();

  @Input() items: OptionItem[] = [];
  @Input() selectedItems: number[] = [];
  @Input() label: string = "";

  checkboxForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.checkboxForm = this.fb.group({
      selectedItems: this.fb.array(
        this.items.map(item => new FormControl(this.selectedItems.includes(item.id)))
      )
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedItems'] && this.checkboxForm) {
      this.itemControls.forEach((control, index) => {
        control.setValue(this.selectedItems.includes(this.items[index].id), { emitEvent: false });
      });
    }
  }

  get itemControls() {
    return (this.checkboxForm.get('selectedItems') as FormArray).controls;
  }

  resetSelection(): void {
    this.itemControls.forEach(control => control.setValue(false, { emitEvent: false }));
    this.checkboxForm.markAsPristine();
    this.checkboxForm.markAsUntouched();
  }

  onSubmit() {
    const selectedIds: number[] = this.checkboxForm.value.selectedItems
      .map((checked: boolean, index: number) => checked ? this.items[index].id : null)
      .filter((id: number | null): id is number => id !== null);

    this.selectionSubmitted.emit(selectedIds);
  }
}
